export const KLARNA_MIN_CART_TOTAL_EUR = 500;
